import type { EventActivity, User } from '@paintscout/api'
import type { CalendarEvent } from 'paintscout'
import { removeAuth0Prefix } from '../../../users/removeAuth0Prefix'
import { formatName } from '../format-name'

export function mapActivitiesToCalendarEvents(
  activities: EventActivity[] = [],
  users?: User[],
  skipFilter?: boolean
): CalendarEvent[] {
  return activities
    .map((activity) => {
      const { _id, details } = activity
      const {
        eventType,
        start,
        end,
        address,
        geocode,
        deal,
        owner,
        contact,
        note,
        canceled,
        crew,
        progress,
        previousProgress,
        production
      } = details
      if (!skipFilter && (!eventType || !start || !end || !owner)) {
        return null
      }

      const user = (users || []).find((user) => removeAuth0Prefix(user.user_id) === removeAuth0Prefix(owner?.id))
      const startDate = start ? new Date(start) : null
      const endDate = end ? new Date(end) : null

      return {
        id: _id,
        eventType,
        start: startDate,
        end: endDate,
        address,
        geocode,
        crew,
        progress,
        previousProgress,
        production,
        deal: deal
          ? {
              id: deal.id,
              source: deal.source,
              name: deal.name,
              value: deal.total,
              hours: deal.hours,
              stage: deal.stage,
              tags: deal.tags
            }
          : undefined,
        estimator: user
          ? {
              id: user.user_id,
              name: user.name,
              color: user.user_metadata.color || '#7fa4d9'
            }
          : owner
            ? {
                id: owner.id,
                name: `${owner.firstName ?? ''} ${owner.lastName ?? ''}`.trim(),
                color: '#7fa4d9'
              }
            : null,
        contact: contact
          ? {
              id: contact.id,
              firstName: contact.firstName,
              lastName: contact.lastName,
              phoneNumber: contact.phoneNumber,
              email: contact.email,
              preferredContactMethod: contact.preferredContactMethod,
              companyId: contact.companyId,
              companyName: contact.companyName
            }
          : undefined,
        note,
        canceled: !!canceled,
        allDay: (startDate && endDate && startDate.toDateString() !== endDate.toDateString()) || production,
        transparency: details.events?.includes('free') ? 'transparent' : 'opaque',
        title: details.title || formatName(contact),
        attendees: details.attendees,
        projectType: details.quoteType
      }
    })
    .filter((event) => event !== null) as CalendarEvent[]
}
